import { ICurrencyExtendedDTO } from '@modeso/types__aumico-lib-settings-be';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, createSelector, MemoizedSelector, on } from '@ngrx/store';
import * as settingsActions from '../actions/settings.actions';
import { ICurrencyState } from '../interfaces/currency-state.interface';

function selectCurrencyId(a: ICurrencyExtendedDTO): string {
    return a._id;
}

function sortByName(a: ICurrencyExtendedDTO, b: ICurrencyExtendedDTO): number {
    return a.name.localeCompare(b.name);
}

const adapter: EntityAdapter<ICurrencyExtendedDTO> = createEntityAdapter<ICurrencyExtendedDTO>({
    selectId: selectCurrencyId,
    sortComparer: sortByName,
});

const { selectEntities, selectAll } = adapter.getSelectors();

export const initialCurrencyState: ICurrencyState = adapter.getInitialState({
    // additional entity state properties
    activeCurrency: null,
    error: null,
});

export function createSelectors<T>(CurrencyStateSelector: MemoizedSelector<T, ICurrencyState>) {
    return {
        selectAll: createSelector(CurrencyStateSelector, selectAll),
        selectEntities: createSelector(CurrencyStateSelector, selectEntities),
        selectActive: createSelector(CurrencyStateSelector, (state) => state.activeCurrency),
        selectError: createSelector(CurrencyStateSelector, (state) => state.error),
    };
}

const privateCurrencyReducer = createReducer(
    initialCurrencyState,
    on(settingsActions.currencyActions.onGetAllCurrencySuccess, (state, action) =>
        adapter.setAll(action.payload, { ...state, error: undefined }),
    ),
    on(settingsActions.currencyActions.onGetAllCurrencyFailed, (state, action) => ({
        ...state,
        error: action.payload,
    })),
);

export function currencyReducer(state: ICurrencyState | undefined, action: Action) {
    return privateCurrencyReducer(state, action);
}
